export type Option = { value: string; label: string };

export const gender: Option[] = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

export const bloodGroup: Option[] = [
  { value: "Unknown", label: "Unknown" },
  { value: "A +ve", label: "A +ve" },
  { value: "A -ve", label: "A -ve" },
  { value: "B +ve", label: "B +ve" },
  { value: "B -ve", label: "B -ve" },
  { value: "AB +ve", label: "AB +ve" },
  { value: "AB -ve", label: "AB -ve" },
  { value: "O +ve", label: "O +ve" },
  { value: "O -ve", label: "O -ve" },
];

export const religion: Option[] = [
  { value: "Islam", label: "Islam" },
  { value: "Christianity", label: "Christianity" },
  { value: "Buddhism", label: "Buddhism" },
  { value: "Other", label: "Other" },
];

export const motherTongue: Option[] = [
  { value: "Urdu", label: "Urdu" },
  { value: "Sindhi", label: "Sindhi" },
  { value: "Punjabi", label: "Punjabi" },
  { value: "Balochi", label: "Balochi" },
  { value: "pashto", label: "Pashto" },
  { value: "English", label: "English" },
];

export const referrers: Option[] = [
  { value: "Friend", label: "Friend" },
  { value: "Family", label: "Family" },
  { value: "Social Media", label: "Social Media" },
  { value: "Newspaper", label: "Newspaper" },
  { value: "Website", label: "Website" },
  { value: "Other", label: "Other" },
];

export const guardianRelations: Option[] = [
  { value: "Uncle", label: "Uncle" },
  { value: "Aunt", label: "Aunt" },
  { value: "Grandfather", label: "Grandfather" },
  { value: "Grandmother", label: "Grandmother" },
  { value: "Brother", label: "Brother" },
  { value: "Sister", label: "Sister" },
  { value: "Other", label: "Other" },
];

// Subset of the full karachiAreas list from the admin panel —
// kept short on purpose; the full list lives in the admin panel.
export const karachiAreas: Option[] = [
  { value: "azizabad", label: "Azizabad" },
  { value: "north-nazimabad", label: "North Nazimabad" },
  { value: "north-karachi", label: "North Karachi" },
  { value: "federal-b-area", label: "Federal B Area" },
  { value: "gulshan-e-iqbal", label: "Gulshan-e-Iqbal" },
  { value: "gulistan-e-johar", label: "Gulistan-e-Johar" },
  { value: "gulshan-e-maymar", label: "Gulshan-e-Maymar" },
  { value: "shah-faisal-colony", label: "Shah Faisal Colony" },
  { value: "malir", label: "Malir" },
  { value: "landhi", label: "Landhi" },
  { value: "korangi", label: "Korangi" },
  { value: "saddar", label: "Saddar" },
  { value: "clifton", label: "Clifton" },
  {
    value: "defence-housing-authority-dha",
    label: "Defence Housing Authority (DHA)",
  },
  { value: "pechs", label: "PECHS" },
  { value: "nazimabad", label: "Nazimabad" },
  { value: "liaquatabad", label: "Liaquatabad" },
  { value: "new-karachi", label: "New Karachi" },
  { value: "scheme-33", label: "Scheme 33" },
  { value: "bahadurabad", label: "Bahadurabad" },
  { value: "shahra-e-faisal", label: "Shahra-e-Faisal" },
  { value: "tariq-road", label: "Tariq Road" },
  { value: "university-road", label: "University Road" },
  { value: "saadi-town", label: "Saadi Town" },
  { value: "bahria-town-karachi", label: "Bahria Town Karachi" },
  { value: "other", label: "Other" },
];
